namespace Nobox.Administration.Pages {
    export interface requestMemberMonth {
        Month?: string;
        Channel?: number;
    }
}
